<script>
import DataViewListVue from '@/app/arch/components/dataView/DataViewList.vue';

export default {
  name: 'CompanyDataView',
  extends: DataViewListVue,
  data: (vm) => ({
    content: [
      {
        text: 'Nome fantasia',
        value: 'tradingName',
      },
      {
        text: 'Razão social',
        value: 'companyName',
      },
      {
        text: 'Documento',
        value: 'cpfCnpj',
        handle: vm.formatDocument,
      },
      {
        text: 'Inscrição estadual',
        value: 'stateRegistration',
        handle: vm.handleState,
      },
    ],
  }),
};
</script>
